export default __webpack_public_path__ + "static/media/iconCardIndicators.0822ab46.svg";